<div class="footer">
    <div class="links">
        <div class="privacy flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-6">
            <a [href]="policyUrl" target="_blank" class="underline text-gray-400 hover:text-gray-500">Privacy Policy</a>
            <a [href]="termsUrl" target="_blank" class="underline text-gray-400 hover:text-gray-500">Terms and Conditions</a>
        </div>
  </div>
</div>